import { useSettings, useStore } from '../context/store';

export default function useUpdateTerm() {
	const { state, dispatch } = useStore();

	const updateTerm = function (taxonomy, term_id, checked) {
		const selectedTaxonomies = { ...state.selectedTaxonomies };

		if (!selectedTaxonomies[taxonomy]) {
			selectedTaxonomies[taxonomy] = [term_id];
		} else if (checked) {
			selectedTaxonomies[taxonomy].push(term_id);
		} else {
			// Remove term from array.
			const index = selectedTaxonomies[taxonomy].indexOf(term_id);
			selectedTaxonomies[taxonomy].splice(index, 1);

			// Delete the taxonomy if it's empty.
			if (!selectedTaxonomies[taxonomy].length) {
				delete selectedTaxonomies[taxonomy];
			}
		}

		dispatch({
			type: 'setSelectedTaxonomies',
			payload: selectedTaxonomies,
		});
	};

	return {
		updateTerm,
	};
}
